import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOn, faToggleOff } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Popconfirm } from 'antd';
import { ProxyCredential } from 'src/types/ProxyServiceInfo';
import axios from 'src/api/axiosInstances/privateAxiosInstance';
import styles from '../ServiceList.module.less';

type ServiceStatusConfirmationProps = {
  record: ProxyCredential;
  handleToggleChange: (newStatus: boolean) => void;
};

const faToggleOnIcon = faToggleOn as IconProp;
const faToggleOffIcon = faToggleOff as IconProp;
const warningText = 'Do you want to Enable/Disable service status for this proxy service?';

const ServiceStatusConfirmation: React.FC<ServiceStatusConfirmationProps> = ({
  record,
  handleToggleChange,
}: ServiceStatusConfirmationProps): React.ReactElement => {
  const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);

  const handleConfirm = async () => {
    const newStatus = !record.enabled;

    try {
      const response = await axios.put(`/qs/anonadmin/editEnabled?proxyId=${record.proxyId}&enabled=${newStatus}`);

      if (response) {
        setConfirmationVisible(false);
        handleToggleChange(newStatus);
      }
    } catch (error) {
      console.error('PUT request error:', error);
    }
  };

  const toggleConfirmation = () => {
    setConfirmationVisible(!confirmationVisible);
  };

  return (
    <span>
      <Popconfirm
        placement="top"
        title={warningText}
        onConfirm={handleConfirm}
        onCancel={toggleConfirmation}
        okText="Yes"
        cancelText="No"
        icon={null}
        visible={confirmationVisible}
      >
        {record.enabled ? (
          <FontAwesomeIcon
            icon={faToggleOnIcon}
            className={styles.status_active_icon}
            size="lg"
            onClick={toggleConfirmation}
          />
        ) : (
          <FontAwesomeIcon
            icon={faToggleOffIcon}
            className={styles.status_inactive_icon}
            size="lg"
            onClick={toggleConfirmation}
          />
        )}
      </Popconfirm>
    </span>
  );
};

export default ServiceStatusConfirmation;
